import { GLHF, Global } from '../../../../../constants';
import { FlexLayout } from '../../../../../components';
import { Result } from '../Result';
import { Format } from '../../../../../utils/string';
import ResultModalModel from '../models/ResultModalModel';

/**
 * 화면 > 그리드 레이아웃 A
 * @window w_tb_e471w_02
 * @category 공사결과보고서
 */
export const ResultModalMisGridHeader: GLHF<ResultModalModel, Result> = (scope) => ([
  {
    id: 'pname',
    text: '구분',
    width: 50,
    render: (x) => (
      <FlexLayout
        align="center"
        justify="start"
      >
        {x.pname}
      </FlexLayout>
    ),
    trail: () => (
      <FlexLayout
        align="center"
        justify="start"
      >
        합계
      </FlexLayout>
    ),
  },
  {
    id: 'punit',
    text: '단위',
    width: 10,
    render: (x) => (
      <FlexLayout
        align="center"
        justify="center"
      >
        {x.punit}
      </FlexLayout>
    ),
  },
  {
    id: 'qty',
    text: '수량',
    width: 10,
    render: (x) => (
      <FlexLayout
        align="center"
        justify="center"
      >
        {Format.number(x.qty)}
      </FlexLayout>
    ),
  },
  {
    id: 'samt',
    text: '매출금액',
    width: 30,
    render: (x) => (
      <FlexLayout
        align="center"
        justify="end"
        style={Global.STYLE_COLOR_BLUE}
      >
        {Format.number(x.samt)}
      </FlexLayout>
    ),
    trail: () => (
      <FlexLayout
        align="center"
        justify="end"
        style={{
          ...Global.STYLE_COLOR_BLUE,
          paddingRight: 8,
        }}
      >
        {Format.number(scope.state.modalMisSamt_tot || '', true)}
      </FlexLayout>
    ),
  },
]);
